const Director = 'Director'
const Manager = 'Manager'
const Analyst = 'Analyst'
const Logistics = 'Logistics'
const Seller = 'Seller'
const SalesExecutive = 'SalesExecutive'

export default [
  {
    path: '/order_history',
    name: 'OrdersHistory',
    component: () => import('@/components/seller/OrdersHistory.vue'),
    meta: {
      auth: true,
      roles: [Manager, Director, Logistics, Analyst, Seller, SalesExecutive ],
    },
  },
  {
    path: '/sell_dashboard',
    name: 'SellDashboard',
    component: () => import('@/components/seller/DoneOrdersByModality.vue'),
    meta: {
      auth: true,
      roles: [Manager, Director, Logistics, Analyst, Seller, SalesExecutive ],
    },
  },
  {
    path: '/order_agenda',
    name: 'OrdersAgenda',
    component: () => import('@/components/seller/OrdersAgenda.vue'),
    meta: {
      auth: true,
      roles: [Manager, Director, Logistics, Analyst, Seller, SalesExecutive ],
    },
  },

]